/**
 * Changes the "parking start date" text.
 */

const startDateSelect = document.getElementById('start-date');
const firstPaymentDate = document.getElementsByClassName('first-payment-date')[0];

const updateStartDate = function updateStartDate() {
  const startDateElement = firstPaymentDate.lastChild;
  console.log(startDateElement);
  if (startDateSelect && startDateElement) {
    const { value } = startDateSelect;
    if (value === 'This Month') {
      const currentDate = new Date();
      const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      const dateString = startDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
      console.log(dateString);
      startDateElement.textContent = `Parking start date: ${dateString}`;
    }
  }
};

const observer = new MutationObserver(updateStartDate);
observer.observe(firstPaymentDate, { childList: true });
